import React from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { useGetApi } from "../../lib/api";
import LargeSpinner from "../common/LargeSpinner";
import RecommendationLayout from "../recommendation/RecommendationLayout";
import Recommendation from "../recommendation/Recommendation";

const SECTIONS = [
  "recommendationHeader",
  "questionsInfo",
  "plrLink",
  "whatWeAreCurrentlyWorkingOn",
  "conclusions",
  "implementationConsiderationsOrRemarks",
  "summaryOfChoices",
  "isof",
  "iEtd",
  "plainLanguageSummarySection",
  "relatedRecommendations",
  "coi",
  "notes",
];

const RecommendationPage = () => {
  const { t } = useTranslation();
  const { id } = useParams();
  const [{ data, isLoading, isError }] = useGetApi(`/recommendations/${id}`);
  return (
    <div className="recommendation font-transat">
      {isError && <div>{t("errors.fetching_failed")}</div>}
      {isLoading ? (
        <LargeSpinner />
      ) : (
        data.document && (
          <RecommendationLayout document={data.document} sections={SECTIONS}>
            <Recommendation />
          </RecommendationLayout>
        )
      )}
    </div>
  );
};

export default RecommendationPage;
